export default "__VITE_ASSET__DUb2pJvh__"